/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';
import { Drawer } from '@mui/material';
import mikeSharedTheme from '../../styles/mikeSharedTheme';

export interface IProps {
  /**
   * Whether panel open or closed.
   */
  open?: boolean;

  /**
   * Nest whatever to want inside the panel.
   */
  children?: React.ReactNode;

}

const DRAWER_WIDTH = 400;

const drawerOpenStyle =  { 
  backgroundColor: mikeSharedTheme.palette.background.default,
  border: 'none',
  position: 'relative',
  height: '100%',
  width: DRAWER_WIDTH,
  overflowX: 'hidden',
  transition: mikeSharedTheme.transitions.create('width', {
    easing: mikeSharedTheme.transitions.easing.sharp,
    duration: mikeSharedTheme.transitions.duration.enteringScreen,
  })
}

const drawerCloseStyle =  {  
  backgroundColor: mikeSharedTheme.palette.background.default,
  border: 'none',
  position: 'relative',
  height: '100%',
  transition: mikeSharedTheme.transitions.create('width', {
    easing: mikeSharedTheme.transitions.easing.sharp,
    duration: mikeSharedTheme.transitions.duration.leavingScreen,
  }),
  width: 0,
  overflowX: 'hidden'
}


const drawerStyle = (open?: boolean) => {
  const drawer = {
    width: DRAWER_WIDTH,
    height: 'calc(100% - 60px)',
    position: 'absolute',
    right: 0,
    top: '60px'
  }
  if (open){
    return {...drawer, drawerOpenStyle}
  }
  else{
    return {...drawer, drawerCloseStyle}
  }
}


const contentStyle = () => {   
  const width = DRAWER_WIDTH
  return css`
    overflow: auto;
    width: ${width}px;
    height: 100%;
    position: relative;
  `; 
}      

// 
/**
 * @name SidePanel
 * @summary A panel 
 */
const SidePanel = (props: IProps) => {
  const {
    children,
    open  
  } = props;

  return (
    <Drawer 
      variant="persistent"    
      anchor="right"
      sx={drawerStyle(open)}    
      open={open}     
      transitionDuration={{
        enter: mikeSharedTheme.transitions.duration.enteringScreen,
        exit: mikeSharedTheme.transitions.duration.leavingScreen
      }}
      PaperProps={{ elevation: open ? 8 : 0, style:  open ? drawerOpenStyle as any : drawerCloseStyle as any}}
    >
      <div css={contentStyle()}>
        {children}
      </div>
    </Drawer>
       
  );
};

export default SidePanel;
